import React, {     useState } from 'react';
import PropTypes from 'prop-types';

import Dropdown from '../../../../components/Dropdown';
import Button from '../../../../components/Button';
import Loader from '../../../../components/Loader';
import { Modal } from 'semantic-ui-react';

import { rejectJob } from '../../../../models/rejectJob';
import './styles.scss';

export const BulkRejectModal = props => {
    const [rejectReason, setRejectReason] = useState(null);
    const [rejectReasonId, setRejectReasonId] = useState(null);
    const [jobwiseReasons, setJobwiseReasons] = useState({});

    const rejectDropdownChange = (event) => {
        const rejectJobReasonSelect = rejectJob.filter((eachReason)=>{
            if(eachReason.id == event.target.value)
                return true;
            return false;
        });

        const reasons = jobwiseReasons;
        props.selectedJobs.map(jobId => {
            reasons[jobId] = {
                rejectReason: rejectJobReasonSelect[0].msg,
                rejectReasonId: event.target.value
            }
        });

        setJobwiseReasons(reasons);
        setRejectReason(rejectJobReasonSelect[0].msg);
        setRejectReasonId(event.target.value);
    };

    const handleItemDropdown = event => {
        const jobid = event.target.attributes['data-jobid'].value;
        const reasonId = event.target.value;
        const rejectJobReasonSelect = rejectJob.filter((eachReason)=>{
            if(eachReason.id == reasonId)
                return true;
            return false;
        });

        setJobwiseReasons(prevValue => {
            const newValue = { ...prevValue };
            newValue[jobid] = {
                rejectReason: rejectJobReasonSelect[0].msg,
                rejectReasonId: reasonId
            }
            return newValue;
        });
    }

    const handleRejectReasonChange = event => {
        setRejectReason(event.target.value);
    }

    const handleRejectConfirm = () => {
        if (Object.keys(jobwiseReasons).length !== props.selectedJobs.length) {
            if (!rejectReason || !rejectReasonId) {
                return alert('Please enter reason!');
            }
        }

        const reasons = jobwiseReasons;
        const reasonArray = Object.keys(jobwiseReasons);
        for (let i=0; i<reasonArray.length; i++) {
            if (!jobwiseReasons[reasonArray[i]].rejectReason && !jobwiseReasons[reasonArray[i]].rejectReasonId) {
                return alert('Please enter reason for all selected jobs');
            }
            if (jobwiseReasons[reasonArray[i]].rejectReasonId == rejectReasonId) {
                reasons[reasonArray[i]] = {
                    rejectReason: rejectReason,
                    rejectReasonId: rejectReasonId
                }
            }
        }

        props.onBulkReject(reasons);
    }

    return (
        <Modal className="bulk-reject-modal" open={props.openModal} onClose={props.onModalClose} closeIcon={true}>
            <Modal.Header className="bulk-reject-header">Bulk Reject</Modal.Header>
            {props.isLoading ? <div className="loader-container">
                <div><Loader /><p>Please Wait...</p></div>
            </div> : null}
            <Modal.Content className="bulk-reject-content">
                
                <div className="content-wrapper">
                    <div className="content-title">You are about to reject {props.selectedJobs.length} job{props.selectedJobs.length===1 ? '' : 's'}. Please select the reason from below:</div>
                    <div className='content-dropdown'>
                        <Dropdown dropdownChange={rejectDropdownChange} className='modal-dropdown' name='rejectJob' data={rejectJob} />
                    </div>
                    <div className='content-textarea'>
                        <label className='textarea-label'>Enter Reason</label>
                        <textarea className="textarea" value={rejectReason} rows='5' maxLength='500' onChange={handleRejectReasonChange} />
                        <div className='textarea-max-limit'>Max 500 characters</div>
                    </div>
                    <div className="content-reasons">
                        <div className="content-reasons-label">Job-wise Reasons: </div>
                        <div className="content-reasons-list">
                            {Object.keys(props.jobsData).map(item => {
                                return (
                                    <div className="content-reasons-item">
                                        <span>{props.jobsData[item]}</span>
                                        <select className="dropdown" data-jobid={item} onChange={handleItemDropdown}>
                                            {rejectJob.map(option => {
                                                if (jobwiseReasons[item] && option.id == jobwiseReasons[item].rejectReasonId) {
                                                    return <option selected value={option.id} key={option.id}>{option.name}</option>
                                                } else {
                                                    return <option value={option.id} key={option.id}>{option.name}</option>
                                                }
                                            })}
                                        </select>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <Button text='Reject' skin='dark' clickButton={handleRejectConfirm} />
                </div>
            </Modal.Content>
        </Modal>
    );
}; 

BulkRejectModal.propTypes = {
    selectedJobs: PropTypes.arrayOf(PropTypes.string).isRequired,
    jobsData: PropTypes.object.isRequired,
    openModal: PropTypes.bool.isRequired,
    onModalClose: PropTypes.func.isRequired,
    onBulkReject: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
}